module.exports = __webpack_public_path__ + "public/images/about-exhibition/bg-desktop-1440.3b4ca3b73b6e6a82fd8fa7e209ce2a92.svg";